import React from 'react';

const ApplicationContext = React.createContext({
  baseURL: null,
  coreCdnHost: null,
  mobileApp: null,
  features: null,
  hydrated: false
});

ApplicationContext.displayName = 'ApplicationContext';
export default ApplicationContext;
